export type ViewMode = 'grid' | 'list';
export type ThemeMode = 'light' | 'dark';

export type Preferences = {
    defaultView: ViewMode;
    themeMode: ThemeMode;
};

export const defaultPreferences: Preferences = {
    defaultView: 'grid',
    themeMode: 'light',
};
